import { UserPlus, Activity, Smartphone } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: UserPlus,
    title: "Registre al paciente",
    desc: "Cree el perfil del paciente con sus datos de contacto y abra su primer episodio de atencion con la evaluacion inicial.",
  },
  {
    number: "02",
    icon: Activity,
    title: "Gestione el episodio",
    desc: "Agende citas, registre notas de sesion, prescriba ejercicios y monitoree el progreso — todo conectado al episodio.",
  },
  {
    number: "03",
    icon: Smartphone,
    title: "El paciente se involucra",
    desc: "Su paciente recibe ejercicios en su portal movil, marca adherencia, confirma citas y reporta su progreso entre sesiones.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-24 md:py-32 bg-white relative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-20">
          <p className="text-sm font-semibold text-emerald-600 uppercase tracking-widest mb-3">
            Como funciona
          </p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-slate-900 tracking-tight mb-4">
            De la primera consulta a la alta medica
          </h2>
          <p className="text-base md:text-lg text-slate-500 leading-relaxed">
            Tres pasos para dar continuidad terapeutica real a cada paciente.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative">
          {/* Connecting line (desktop only) */}
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-[2px] bg-gradient-to-r from-emerald-300 via-emerald-200 to-emerald-300 z-0" />

          {steps.map((step, i) => (
            <div
              key={i}
              data-testid={`step-card-${i}`}
              className="relative z-10 text-center group"
            >
              {/* Number circle */}
              <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-500 rounded-2xl mb-6 shadow-lg shadow-emerald-500/20 group-hover:scale-110 transition-transform duration-300">
                <step.icon className="w-7 h-7 text-white" />
              </div>

              {/* Step number */}
              <p className="text-xs font-bold text-emerald-500 tracking-widest mb-2">
                PASO {step.number}
              </p>

              <h3 className="font-heading font-semibold text-xl text-slate-800 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed max-w-xs mx-auto">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
